module.exports = __webpack_public_path__ + "static/about-img-24e358fad0a44bf6490402a057fc62d2.jpg";